/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QuotaExceededHitsBucketFromJSON, QuotaExceededHitsBucketToJSON } from './QuotaExceededHitsBucket';
/**
 * Check if a given object implements the QuotaExceededHitsResponse interface.
 */
export function instanceOfQuotaExceededHitsResponse(value) {
    if (!('days' in value) || value['days'] === undefined)
        return false;
    if (!('free' in value) || value['free'] === undefined)
        return false;
    if (!('hoursSinceLastEventEver' in value) || value['hoursSinceLastEventEver'] === undefined)
        return false;
    if (!('overall' in value) || value['overall'] === undefined)
        return false;
    if (!('paid' in value) || value['paid'] === undefined)
        return false;
    return true;
}
export function QuotaExceededHitsResponseFromJSON(json) {
    return QuotaExceededHitsResponseFromJSONTyped(json, false);
}
export function QuotaExceededHitsResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'days': json['days'],
        'free': QuotaExceededHitsBucketFromJSON(json['free']),
        'hoursSinceLastEventEver': json['hoursSinceLastEventEver'],
        'overall': QuotaExceededHitsBucketFromJSON(json['overall']),
        'paid': QuotaExceededHitsBucketFromJSON(json['paid']),
    };
}
export function QuotaExceededHitsResponseToJSON(json) {
    return QuotaExceededHitsResponseToJSONTyped(json, false);
}
export function QuotaExceededHitsResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'days': value['days'],
        'free': QuotaExceededHitsBucketToJSON(value['free']),
        'hoursSinceLastEventEver': value['hoursSinceLastEventEver'],
        'overall': QuotaExceededHitsBucketToJSON(value['overall']),
        'paid': QuotaExceededHitsBucketToJSON(value['paid']),
    };
}
